import React from 'react';
import { Chip } from '@mui/material';
import { getStatusToken } from '../utils/statusTokens';

/**
 * Status chip with hard-coded spec color tokens. Renders the status label
 * inside the chip and exposes an aria-label so screen readers announce the
 * semantic state (color is never the only signal).
 */
const ApprovalStatusChip = ({ status, size = 'small' }) => {
  const token = getStatusToken(status);
  return (
    <Chip
      label={token.label}
      size={size}
      aria-label={`Status: ${(status || 'draft').toLowerCase()}`}
      sx={{
        bgcolor: token.bg,
        color: token.fg,
        fontWeight: 700,
        fontSize: 14,
        borderRadius: '4px',
        height: 'auto',
        '& .MuiChip-label': { px: '10px', py: '4px' },
      }}
    />
  );
};

export default ApprovalStatusChip;
